import React, { memo, useState } from 'react';
import s from './DataBar.scss';
import { getPercentageValue } from '../../utils/computation';

const DataBar = ({ color, name, ws, wsc = null, ttl_seat }) => {
  const firstBarWidth = getPercentageValue(ws, ttl_seat);
  const secondBarWidth = getPercentageValue(wsc, ttl_seat);
  const [width1, setWidth1] = useState(0);
  const [width2, setWidth2] = useState(0);
  setTimeout(() => {
    setWidth1(firstBarWidth);
    setWidth2(secondBarWidth);
  }, 0);
  return (
    <div className={s.bar}>
      <div className={s.partyName} style={{ color }}>
        {name}
      </div>
      <div className={s.barWrapper}>
        {ws > 0 && (
          <div
            className={`${s.bars}`}
            style={{ 'background-color': color, width: `${width1}%` }}
          />
        )}
        {wsc > 0 &&
          secondBarWidth && (
            <div
              className={`${s.bars} ${s.secondBar}`}
              style={{
                'background-color': color,
                width: `${width2}%`,
              }}
            />
          )}
      </div>
      {wsc != null &&
        (ws === wsc ? (
          <div className={s.range}>{`${isNaN(ws) ? 0 : ws}`}</div>
        ) : (
          <div className={s.range}>
            {`${isNaN(ws) ? 0 : ws} - ${isNaN(wsc) ? 0 : wsc}`}
          </div>
        ))}
      {wsc == null && <div className={s.range}>{isNaN(ws) ? 0 : ws}</div>}
    </div>
  );
};

export default memo(DataBar);
